import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';


export const aMOpsApi = createApi({
  reducerPath: 'aMOpsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['analytics'],
  endpoints: builder => ({
    // Get ops analytics
    getOps: builder.query({
      query: (params) => ({
        url: '/analytics/get-ops/',
        params,
      }),
      providesTags: ['analytics']
    }),
  }),
});

export const {
  useGetOpsQuery,
} = aMOpsApi;
